module.exports = __webpack_public_path__ + "VodafoneRg_W.958a3fd7f65dc0ca5bfd.woff";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/fonts/VodafoneRg_W.woff
// module id = ../../../../../src/assets/fonts/VodafoneRg_W.woff
// module chunks = styles